import React from 'react';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import InstructorCalendar from '@/components/instructor/InstructorCalendar';
import { Calendar, Clock } from 'lucide-react';

const InstructorDashboard = () => {
  return (
    <DashboardLayout role="instructor">
      <div className="space-y-8 h-full flex flex-col">
        <div className="flex flex-col space-y-2 flex-none">
          <div className="flex items-center space-x-2">
            <Calendar className="h-8 w-8 text-primary" />
            <h1 className="text-3xl font-bold">Instructor Schedule</h1>
          </div>
          <p className="text-gray-600">View and manage your teaching schedule</p>
        </div>

        <div className="grid gap-8 flex-1 min-h-0">
          <Card className="h-full flex flex-col border">
            <CardContent className="p-0 flex-1 min-h-0">
              <InstructorCalendar />
            </CardContent>
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default InstructorDashboard;
